import { axios, Response } from '../index'

const uncheckConfiguration = (settingId: string): Response<null> => {
  return axios.put(`/v1/settings/${settingId}/uncheck`)
}

export default uncheckConfiguration
